import React from "react";
import { FiLink } from "react-icons/fi";
import Masonry from "react-masonry-css";

const breakpointColumnsObj = {
  default: 3,
  1100: 3,
  700: 2,
  500: 1,
};

// Puedes actualizar estas imágenes con versiones más largas (full-page screenshots) para que el scroll se note más.
const portfolioItems = [
  {
    img: "/img/portfolio/m-portfolio-1.png",
    title: "Cultivos Protegidos de Occidente",
    subTitle: "Desarrollo de plataforma para ingeniería de invernaderos.",
    delayAnimation: "100",
    portfolioLink: "https://cprotegidos.com/",
  },
  {
    img: "/img/portfolio/m-portfolio-2.png",
    title: "Acuícola Ventarrón",
    subTitle: "Digitalización de procesos de producción de Tilapia.",
    delayAnimation: "200",
    portfolioLink: "https://ventarrontilapia.com",
  },
  {
    img: "/img/portfolio/m-portfolio-3.png",
    title: "Siidocks Systems",
    subTitle: "Transformación digital e infraestructura.",
    delayAnimation: "0",
    portfolioLink: "https://siidockssystems.mx",
  },
  {
    img: "/img/portfolio/m-portfolio-4.png",
    title: "Grado Estudio",
    subTitle: "Desarrollo de plataforma educativa en arquitectura.",
    delayAnimation: "100",
    portfolioLink: "https://grados.com.mx/",
  },
  {
    img: "/img/portfolio/m-portfolio-5.png",
    title: "Sii Industrial",
    subTitle: "Desarrollo de plataforma para servicios industriales.",
    delayAnimation: "100",
    portfolioLink: "https://sii-industrial.com",
  },
  {
    img: "/img/portfolio/m-portfolio-6.png",
    title: "Ares Arquitectos",
    subTitle: "Transformación digital de firma líder en construcción.",
    delayAnimation: "200",
    portfolioLink: "https://aresarquitectos.com",
  },
];

const LiveMockupPortfolio = () => {
  return (
    <div className="live-mockup-container portfolio-content">
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {portfolioItems.map((val, i) => (
          <div
            className="live-mockup-item"
            key={i}
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay={val.delayAnimation}
          >
            {/* Contenedor del Mockup estilo iPad */}
            <div className="live-mockup-ipad">
              {/* Cámara del iPad */}
              <div className="ipad-camera"></div>
              
              <div className="mockup-screen">
                <img
                  src={val.img}
                  alt={val.title}
                  className="mockup-scroll-img"
                />
              </div>
              
              <a
                href={val.portfolioLink}
                target="_blank"
                rel="noreferrer"
                className="mockup-overlay-link"
                title="Visitar sitio web"
              >
                <FiLink />
              </a>
            </div>

            {/* Información del Proyecto */}
            <div className="mockup-info">
              <h5>
                <a href={val.portfolioLink} target="_blank" rel="noreferrer">
                  {val.title}
                </a>
              </h5>
              <span>{val.subTitle}</span>
            </div>
          </div>
        ))}
      </Masonry>
    </div>
  );
};

export default LiveMockupPortfolio;
